import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analyticsConfig } from "@/config/analytics";

const GTM_SCRIPT_MARKER = "data-ad-gtm";
const META_SCRIPT_MARKER = "data-ad-meta-pixel";

const loadGtm = (containerId) => {
  if (window.__adGtmContainerId === containerId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.setAttribute(GTM_SCRIPT_MARKER, containerId);
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  document.head.appendChild(script);

  if (!document.querySelector(`noscript[${GTM_SCRIPT_MARKER}]`)) {
    const noscript = document.createElement("noscript");
    noscript.setAttribute(GTM_SCRIPT_MARKER, containerId);
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(containerId)}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    iframe.title = "Google Tag Manager";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  window.__adGtmContainerId = containerId;
};

const loadMetaPixel = (pixelId) => {
  if (window.__adMetaPixelId === pixelId) return;

  if (!window.fbq) {
    const queue = function () {
      if (queue.callMethod) {
        queue.callMethod.apply(queue, arguments);
      } else {
        queue.queue.push(arguments);
      }
    };
    queue.queue = [];
    queue.push = queue;
    queue.loaded = true;
    queue.version = "2.0";
    window.fbq = queue;
    if (!window._fbq) window._fbq = queue;

    const script = document.createElement("script");
    script.async = true;
    script.setAttribute(META_SCRIPT_MARKER, pixelId);
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  window.fbq("init", pixelId);
  window.__adMetaPixelId = pixelId;

  if (!document.querySelector(`noscript[${META_SCRIPT_MARKER}]`)) {
    const noscript = document.createElement("noscript");
    noscript.setAttribute(META_SCRIPT_MARKER, pixelId);
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.src = `https://www.facebook.com/tr?id=${encodeURIComponent(pixelId)}&ev=PageView&noscript=1`;
    img.alt = "";
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }
};

const trackPageView = (pagePath) => {
  if (analyticsConfig.isGtmEnabled && window.dataLayer) {
    window.dataLayer.push({
      event: "page_view",
      page_path: pagePath,
      page_title: document.title,
    });
  }

  if (analyticsConfig.isMetaPixelEnabled && window.fbq) {
    window.fbq("track", "PageView");
  }
};

export const AnalyticsTags = () => {
  const location = useLocation();
  const pagePath = `${location.pathname}${location.search}`;

  useEffect(() => {
    const { gtmContainerId, metaPixelId } = analyticsConfig;

    if (gtmContainerId) loadGtm(gtmContainerId);
    if (metaPixelId) loadMetaPixel(metaPixelId);
  }, []);

  useEffect(() => {
    if (!analyticsConfig.isGtmEnabled && !analyticsConfig.isMetaPixelEnabled) {
      return;
    }

    trackPageView(pagePath);
  }, [pagePath]);

  return null;
};
